var Locator = function (config, location) {
    var _location = location
    var _config = config
    var _cache = {}
    
    function findLocationTemplate (service) {
      for (var i = 0; i < _config.locations.length; i++) {
        var location = _config.locations[i]
        if (location.service && location.service != service) continue
        var regStr = location.location
          .split('.').join('\.')
          .split('*').join('.*')
        regStr = '^' + regStr + '$'
        var reg = new RegExp(regStr)
        if (!reg.test(window.location.origin)) continue
        return location.template
      }
    }
  
    function getLocationTemplate (location) {
      if (location[location.length - 1] === '/') location = location.substring(0, location.length - 1)
      return location.replace(_config.self, '{name}')
    }
  
    function getServiceLocation (name) {
      var template =_location
        ? getLocationTemplate(_location)
        : findLocationTemplate(name)
      return template
        .replace('{name}', name)
        .replace('{port}', window.location.port)
    }
  
    function getServiceLocationCached (name) {
      if (_cache.hasOwnProperty(name)) return _cache[name]
      var location = getServiceLocation(name)
      _cache[name] = location
      return location
    }
  
    this.getService = function (name) {
      return getServiceLocationCached(name)
    }
  
    this.getSelf = function () {
      return getServiceLocationCached(_config.self)
    }
  }
  function Manifest (selfUrl) {
    var _selfUrl = selfUrl
    var _manifest
    var _config = {
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      }
    }
  
    function getManifest () {
      var url = _selfUrl + '/manifest.json'
      return fetch(url, _config)
        .then(function (response) {
          return response.json()
            .then(function (json) {
              return json
            })
        })
        .catch(function (error) {
          console.error('Manifest.error', error)
          return undefined
        })
    }
  
    function getManifestCached () {
      if (_manifest) {
        return Promise.resolve(_manifest)
      } else {
        return getManifest()
          .then(function (manifest) {
            _manifest = manifest
            return manifest
          })
      }
    }
  
    this.getPath = function (name) {
      return getManifestCached()
        .then(function (manifest) {
          return manifest[name]
        })
    }
  }
  
  var Translator = function (options) {
    var _locator = new Locator(options.locatorConfig)
    var _manifest = new Manifest(_locator.getSelf())
    
    var _locale = undefined
    var _locales = {}
  
    function getLocale(locale) {
      return _manifest.getPath('locales/' + locale + '.json')
        .then(function (path) {
          var url = _locator.getSelf() + path
          return fetch(url)
            .then(function (response) {
              return response.json()
                .then(function (json) {
                  return json
                })
            })
            .catch(function (error) {
              console.error(error)
              return null
            })
        })
        .catch(function (error) {
          console.error(error)
          return null;
        })
    }
  
    function getLocaleCached(locale) {
      if (_locales[locale] !== undefined) return new Promise(function (resolve) {
        resolve(_locales[locale])
      })
  
      return getLocale(locale)
        .then(function (data) {
          _locales[locale] = data
          return data
        })
    }
  
    function getTranslation(messages, key) {
      var keys = key.replace(/\[([^\]]+)\]/g, '.$1').split('.')
      for (var i = 0; i < keys.length; i++) {
        if (messages === undefined || messages === null) break
        messages = messages[keys[i]]
      }
      return typeof messages === 'string'
        ? messages
        : key
    }
  
    function applyParams(translation, params) {
      return Object.keys(params)
        .reduce(function (acc, item) {
          return acc.replace('{' + item + '}', params[item])
        }, translation)
    }
  
    function translate(key, params) {
      var translation = getTranslation(_locales[_locale], key)
      var result = applyParams(translation, params)
      return result
    }
  
    this.init = function (locale) {
      _locale = locale
      return getLocaleCached(locale)
        .then(function (messages) {
          return messages != null
        })
    }
  
    this.getOutcomeFullName = function (outcome) {
      var key = 'enums.outcomeFullName[' + outcome.c + '-' + outcome.t + ']'
      return translate(key, outcome)
    }
  
  }
  
  
  var options = {
    "name":"bkTranslator",
    "locatorConfig":{
        "self":"player-widget-a",
        "locations":[
            {"location":"http://*.book.internal","template":"http://{name}.book.internal"},
            {"location":"http://*.book.internal:*","template":"http://{name}.book.internal:{port}"},
            {"location":"http://localhost:*","template":"http://{name}.lbltest.ru"},
            {"location":"http://local.host:*","template":"https://{name}.lbltest.ru"},
            {"location":"http://*.lbltest.ru","template":"http://{name}.lbltest.ru"},
            {"location":"https://*.lbltest.ru","template":"https://{name}.lbltest.ru"},
            {"location":"https://*.bet777.tk","template":"https://{name}.lbltest.ru"},
            {"location":"https://*.mbk777.gq","template":"https://{name}.lbltest.ru"},
            {"location":"https://*.mktest.xyz","template":"https://{name}.lbltest.ru"},
            {"location":"https://*.betngo.org","template":"https://{name}.lbltest.ru"},
            {"location":"http://test.flg.bet","template":"https://{name}.lbltest.ru"},
            {"location":"https://cashier.mbktest.com","template":"https://{name}.lbltest.ru"},
            {"location":"*","template":"https://{name}.livebetline.com"}
        ],
        "configs":{
            "test":{
                "self":"player-widget-a",
                "locations":[
                    {"location":"*","template":"https://{name}.lbltest.ru"}
                ]
            },
            "prod":{
                "self":"player-widget-a",
                "locations":[
                    {"location":"*","template":"https://{name}.livebetline.net"}
                ]
            }
        }
    }
  }
  
  export default new Translator(options)


// WEBPACK FOOTER //
// ./_common/services/bk.translator.service.js